import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';

import { generateCollectionCommands } from './generateCollectionCommands';
import { expenseTypeConfig } from '../components/Overview/CustomerData/Expenses/expenseTypeConfig.ts';
import type { SchemaExpensesForm } from '../schemas/expenses.schema';

const emptyExpenses: SchemaExpensesForm = {
    mietausgaben: [],
    privateKrankenversicherungen: [],
    sonstigeAusgaben: [],
    unterhaltsverpflichtungen: [],
};

export function generateExpenseCommands(
    oldData: SchemaLoanRequestResolver_Get['haushalt']['ausgaben'],
    newData: SchemaExpensesForm,
) {
    const previous =
        oldData === undefined
            ? undefined
            : {
                  mietausgaben: oldData.mietausgaben ?? emptyExpenses.mietausgaben,
                  privateKrankenversicherungen:
                      oldData.privateKrankenversicherungen ?? emptyExpenses.privateKrankenversicherungen,
                  sonstigeAusgaben: oldData.sonstigeAusgaben ?? emptyExpenses.sonstigeAusgaben,
                  unterhaltsverpflichtungen:
                      oldData.unterhaltsverpflichtungen ?? emptyExpenses.unterhaltsverpflichtungen,
              };

    return generateCollectionCommands(previous, newData, expenseTypeConfig, (item) => ({
        gehoertZuAntragsteller: item.gehoertZuAntragsteller,
        id: item.id,
    }));
}
